"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getSpecies_1 = require("./getSpecies");
exports.transform = function (stream, fn) {
    var C = getSpecies_1.getSpecies(stream);
    return new C(function (observer) {
        var index = 0;
        return stream.subscribe({
            next: function (value) {
                try {
                    fn(observer, value, index);
                    index += 1;
                }
                catch (e) {
                    observer.error(e);
                }
            },
            error: function (e) {
                observer.error(e);
            },
            complete: function () {
                observer.complete();
            }
        });
    });
};
//# sourceMappingURL=transform.js.map